module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-regular.cffb686d.woff2";